import { useContext, useEffect, useState } from "react";
import { GET_NEWS_BY_ID, GET_NRI_TALK_BY_ID, fetchData } from "../../components/Service";
import { useParams } from "../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../components/Context";
import _ from "lodash";
import moment from "../../../node_modules/moment/moment";
import { getEmbededYoutubeUrl, scrollTop } from "../../components/Helper";
import Share from "../../components/Share";

const NewsDetails = () => {
	const { news_id } = useParams();
	const [context] = useContext(Context);
	const [data, setData] = useState();

	const getDetails = (news_id) => {
		let payload = {
			news_id: news_id,
		};

		fetchData(GET_NEWS_BY_ID, "POST", payload, true, false, (res) => {
			if (res.status) {
				setData(res?.data);
			} else {
				setData();
			}
		});
	};

	useEffect(() => {
		scrollTop();
		if (news_id) {
			getDetails(news_id);
		}
	}, [news_id]);

	return (
		<div class="col-lg-12">
			<div class="card card-forum ">
				<div class="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-12">
								<h4 class="text-white d-flex mb-0 py-2">{_.startCase(data?.title)}</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white p-1">
					<div class="card mb-3">
						<div className="card-header p-1">
							<ul className="point-list">
								<li>
									<span>
										<i class="fi fi-rr-calendar-lines"></i>
									</span>{" "}
									{data?.created_at ? moment(data?.created_at).format("DD-MMM-YYYY") : ""}
								</li>
								<li>
									<span>
										<i class="fi fi-rs-user"></i>
									</span>{" "}
									Admin
								</li>
							</ul>
						</div>
						<div class="row g-0 align-items-stretch">
							<div class="col-xl-4">
								<iframe src={data?.video_link ? getEmbededYoutubeUrl(data?.video_link) : ""} height={300} title="YouTube Video" allowFullScreen />
								{/* <img src={data?.image ? data?.image : "/assets/images/no-image.jpg"} class="img-fluid rounded-3" /> */}
							</div>
							<div class="col-xl-8">
								<div class="card-body h-100">
									<h6>Description</h6>
									<p class="card-text">{data?.description}</p>
								</div>
							</div>
							<div class="col-md-12">
								<div class="card-body h-100">
									<Share url={`https://${process.env.REACT_APP_DOMAIN_URL}/news-articles/${data?.id}`}
									id={data?.id}
									type="news-articles"
									/>
								</div>
							</div>
						</div>
					</div>
					{data?.comment?.data && data.comment.data.length > 0 && (
						<div className="row">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header">
										<h6>Comments ({data?.comment?.total})</h6>
									</div>
									<div className="card-body">
										<ul className="comments-list">
											{data?.comment?.data?.map((item) => (
												<li key={item?.id}>
													<span className="img-user">{item?.user?.image ? <img src={item?.user?.image} /> : <img src="/assets/images/slide1-1480.jpg" />}</span>
													<h6>
														{item?.user?.first_name} {item?.user?.last_name}
													</h6>
													<p className="mt-1">{item?.comment}</p>
												</li>
											))}
										</ul>
									</div>
								</div>
							</div>
						</div>
					)}
					{/* <div className="row my-2">
						<div className="col-md-12">
							<div className="card">
								<div className="card-header">
									<h6>Post Comments</h6>
								</div>
								<div className="card-body">
									<div class="mb-3">
										<label for="Respond" class="form-label">
											Respond to Talk
										</label>
										<textarea class="form-control" id="Respond" rows="5"></textarea>
										<div className="text-end mt-2">
											<a class="btn btn-light font13 d-inline-flex align-items-center me-2" href="">
												Cancel
											</a>
											<a class="btn btn-warning font13 d-inline-flex align-items-center" href="">
												Post Comment <i class="fi fi-rr-arrow-small-right ms-2"></i>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div> */}
				</div>
			</div>
		</div>
	);
};

export default NewsDetails;
